import { WithRef } from '@principle-theorem/shared';
import { type IInvoice } from '../../invoice/invoice';
import { ITransaction } from '../../transaction/transaction';
import { type ITemplateContext } from '../templating';
import { type IBaseTemplateContext } from './base-context';
import {
  IPatientTemplateContext,
  type IPatientScopeData,
} from './patient-context';
import { IPracticeTemplateContext } from './practice-context';
import { IPractice } from '../../practice/practice';

export interface IInvoiceScopeData extends IPatientScopeData {
  invoice: IInvoice;
  transactions: WithRef<ITransaction>[];
  practice: WithRef<IPractice>;
  invoiceLink: string;
}

export interface IInvoiceTemplateContext
  extends ITemplateContext,
    IPatientTemplateContext,
    IPracticeTemplateContext,
    IBaseTemplateContext {
  invoiceLink: string;
  invoiceCreatedAt: string;
  invoiceCreatedAtDate: string;
  invoiceCreatedAtTime: string;
  invoiceReference: string;
  invoicePracticeName: string;
  invoiceAmount: string;
  invoiceBalance: string;
  invoiceDueDate: string;
}
